import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { AttachingCertificateComponent, ImagesComponent } from 'src/app/components/dialog';
import { PaginationInput, PaginationPageEvent, ListParams, Res, Product, ReferenceParams, AttributeModel } from 'src/app/models';
import { LanguageService, DialogModalService, ApiProductsService, FilesService, PermissionService, NotificationService, ApiOrganizationsService } from 'src/app/services';
import { TreeviewItem } from 'ngx-treeview';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { AttributeModelForProductTableComponent } from 'src/app/components/dialog/products/attribute-model-for-product-table/attribute-model-for-product-table.component';
import { GalleryService } from '@ks89/angular-modal-gallery';
import { ProductsAttributesEditComponent } from 'src/app/components/dialog/attributes/products-attributes-edit/products-attributes-edit.component';
import { ApiAttributesService } from 'src/app/services/api-attributes.service';

import { GridLayout, Image, PlainGalleryConfig, PlainGalleryStrategy } from '@ks89/angular-modal-gallery';
import { Router } from '@angular/router';
import { ApiCategoriesService } from 'src/app/services/api-categories.service';
import { ProductsDataDownloadComponent } from 'src/app/components/dialog/files/products-data-download/products-data-download.component';
import { ApiSettingsService } from 'src/app/services/api-settings.service';
import { ACTIONS_LIST, OPERATORS_FOR_CONDITION } from 'src/app/constants/products/products-list-actions';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FileterConditions } from 'src/app/models/filter-conditions.model';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { CustomersIntegrationComponent } from 'src/app/components/dialog/products/customers-integration/customers-integration.component';
import { ApiBasicService } from 'src/app/services/api-basic.service';
import { PaginationService } from 'src/app/services/pagination.service';

export interface Item {
  id: string;
  name: string;
  parent_id: string;
  parent_name: string;
}

export type ProductsSortDirection = 'asc' | 'desc' | '';
@Component({
  selector: 'app-products-list',
  templateUrl: './products-list.component.html',
  styleUrls: ['./products-list.component.css']
})
export class ProductsListComponent implements OnInit {
  private readonly hiddenColumnNames: string[] = [
    'вариант (вкус, цвет, тип ул.)'
  ];

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  products: Product[] = [];
  ids: any[] = [];
  status: string;
  productsData: any[] = [];
  categories: any[] = [];
  operators: any[] = [];
  attributes: AttributeModel[] = [];
  configuredData: any[] = [];
  configuredAttirubes: string[] = [];
  firstLoad: number = 0;
  attrsForTable: any[] = [];
  defaultAttrsForTable: string[] = [];
  editField: any;
  showFiedlForEdit: any[] = [];
  isGalleryOpen: boolean;
  activeGalleryImages: Image[] = [];
  currentOrgData: any;
  categoriesIds: string[] = [];
  actionsList = ACTIONS_LIST;
  tags: any[] = [];
  component: string;
  settingVue: boolean;
  allIds: string[] = [];
  checkRole: boolean;
  editable: boolean;

  // Пагинация
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;

  //Сортировака данных продукта
  collapsed = true;
  sort: any = {};
  direction: ProductsSortDirection = 'asc';
  headerDirection: any[] = [];
  columnDirection: string;
  hiddenCategory: boolean;
  hiddenFilter: boolean;


  //Фильтрация продуктов
  filter: any;
  selectedOperatorsForCondition: string = 'AND';
  condition = {
    [this.selectedOperatorsForCondition]: []
  };
  filterConditionData: FileterConditions[] = [];
  filterCategoryStatus: boolean = false;
  categoryCondition = {
    attribute_id: "6e218c45-a642-48ab-86e7-5c0af242819b",
    operator: "contains",
    value: []
  };

  operatorsForCondition = OPERATORS_FOR_CONDITION;

  //Контекстное меню для выбора способа перехода в профиль продукта
  title = 'context-menu';
  isDisplayContextMenu: boolean;
  rightClickData: Array<any> = [];
  contextFieldName: string;
  rightClickMenuPositionX: number;
  rightClickMenuPositionY: number;

  @ViewChild('widgetsContent') widgetsContent: ElementRef;

  tableFieldsForm: UntypedFormGroup = this.fb.group({
    attribute_id: ['']
  })

  dropdownEnabled = true;
  items: TreeviewItem[] = [];
  itemsLoading: boolean;
  categorieslength: number;
  values: number[];
  categoryType: string = 'categories';
  changeItem: any;
  

  plainGalleryGrid: PlainGalleryConfig = {
    strategy: PlainGalleryStrategy.GRID,
    layout: new GridLayout({ width: '48px', height: '48px' }, { length: 1, wrap: false })
  };

  countSelectedFiles: number;
  amount: any;

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private fileService: FilesService,
    private apiProducts: ApiProductsService,
    private apiAttributes: ApiAttributesService,
    private dialogModal: DialogModalService,
    private galleryService: GalleryService,
    public permissionAccess: PermissionService,
    private notification: NotificationService,
    private router: Router,
    private apiCategoriesService: ApiCategoriesService,
    private apiOrganizationsService: ApiOrganizationsService,
    private apiSettings: ApiSettingsService,
    private sanitizer: DomSanitizer,
    private apiBasic: ApiBasicService,
    private paginationService: PaginationService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.permissionAccess.currentModule = 'PRODUCTS';
    this.permissionAccess.getActions('PRODUCTS');
    this.currentOrgData = this.apiOrganizationsService.currentOrganization;
    this.defaultAttrsForTable = this.apiSettings.getSettingValues('PRODUCTS_LIST_DEFAULT_FIELDS', 'array');

    this.checkOrg();

    this.getAttributesIdsForDisplay();

    if (this.permissionAccess.check('REFERENCES_CATEGORIES')) {

      // this.setStateCategoryBox();
    }

    if (this.permissionAccess.check('REFERENCES_FILTER_CONDITIONS_OPERATORS')) {

      this.getOperators();
    }

    if (this.permissionAccess.check('REFERENCES_ATTRIBUTES')) {
      this.getAttributes();
    }

    if (this.permissionAccess.check('REFERENCES_CATEGORIES')) {
      this.getCategories();
    }



    //Проваливаемся на первый уровень в дереве категорий через id "все товары"
    // this.onSelectedChange(['8f9e5fe8-dbfc-4856-884c-4e3f00554690']);

    this.subscriptions.add(
      this.apiOrganizationsService.listenerCurrentOrganization().subscribe(val => {

        this.currentOrgData = val;
      })
    );

    this.subscriptions.add(
      this.apiSettings.listenerSettings().subscribe(val => {

        if (val) {

          this.defaultAttrsForTable = this.apiSettings.getSettingValues('PRODUCTS_LIST_DEFAULT_FIELDS', 'array');
        }
      })
    );

    this.subscriptions.add(
      this.paginationService.listenerPaginationListData().subscribe(val => {

        if (val) {
          
          this.pageEvent(val);
          
        }
      })
    );

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
    * 
    * @returns boolean
    */
  checkState(action: string): boolean {

    if (this.checkedCheckBox()) {

      return this.permissionAccess.check(action);
    }

    return false;

  }


  /**
   * 
   * @param attribute 
   */
  enableEdit(attribute: any, productId: string): void {

    attribute.editable = true;

    // let inputValue = {
    //   attrsData: attribute, 
    //   productData: productId, 
    //   defaultStyle: false
    // }

    // this.dialogModal.open(inputValue, ProductsAttributesEditComponent, '', 'attr-window').then(
    //   (result) => {

    //     if (result) {

    //       // this.changeValue.emit(true);
    //     }
    //   },
    //   () => { console.log('Rejected!'); }
    // );

  }


  /**
   * 
   * @param product_id 
   * @param value 
   * @param fieldName 
   */
  updateList(i, j, product: Product, attribute, inputData) {

    console.log("INPUT DATA PROD LIST: ", inputData);


    let data: any = {
      product_id: [product.id],
      attribute_id: attribute.id,
      attribute_group_id: attribute.attribute_group_id,
      attribute_value: inputData.content_type == 'COMBOBOX_MULTIPLE' || inputData.content_type == 'COMBOBOX' ? String(inputData.value) : inputData.value
    }

    this.subscriptions.add(
      this.apiAttributes.attributeUpdate(data).subscribe((response: any) => {

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.products[i].attributes[j]['editable'] = false;
          this.products[i].attributes[j]['display_value'] = inputData.content_type == 'COMBOBOX_MULTIPLE' || inputData.content_type == 'COMBOBOX' ? inputData.display_value : inputData.value

          if (inputData.content_type == 'COMBOBOX_MULTIPLE' || inputData.content_type == 'COMBOBOX') {

            this.products[i].attributes[j]['value'] = String(inputData.value);
          }

          if (inputData.content_type == 'TAGS' || inputData.content_type == 'CERTIFICATE' || inputData.content_type == 'FILE') {

            this.products[i].attributes[j].attribute_additional_info = inputData.attrs_addInfo_data;
          }
        }
      })
    );

  }

  /**
   * 
   * @param attribute 
   */
  rejectEdit(attribute) {

    attribute.editable = !attribute.editable;

    this.editable = !false;

  }

  /**
   * 
   * @param product_id 
   * @param attributes 
   */
  updateAttrList(product_id: number, attributes) {

    let data: any = {
      product_id: [product_id],
      attribute_id: attributes.id,
      attribute_value: attributes.value
    }

    this.subscriptions.add(
      this.apiAttributes.attributeUpdate(data).subscribe((response: any) => {

        console.log("ATTRS UPDATE: ", response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
        }
      })
    );

  }

  /**
   * 
   * @param value 
   */
  eventCategoryList(item: any): void {

    let duplicate = this.condition[this.selectedOperatorsForCondition].findIndex(val => val.attribute_id == this.categoryCondition.attribute_id);

    if (duplicate > -1) {

      this.condition[this.selectedOperatorsForCondition].splice(duplicate, 1);
    }

    if (item.checked) {

      this.categoriesIds.push(item.id)

      this.categoryCondition.value = this.categoriesIds;

    }
    else {

      let index = this.categoriesIds.findIndex(val => val == item.id)

      if (index > -1) {

        this.categoriesIds.splice(index, 1);
        this.categoryCondition.value = this.categoriesIds;
      }

    }

    this.getList();

  }


  /**
   * 
   * @param searchValue - значение для поиска вводимое вручную
   * @param currentElemId - текущее значение из справочника передаваемое при его выборе из списка
   */
  getCategories(searchValue: any = '', currentElemId: any = ''): void {

    let params: ReferenceParams = {
      ref_name: 'categories',
      filter: {
        name: searchValue,
        parent_id: currentElemId
      }
    }

    this.itemsLoading = true;

    this.subscriptions.add(

      this.apiCategoriesService.getReferences(params, params.ref_name).subscribe((response: Res) => {
        console.log("[RESPONSE] references/categories: ", response);

        if (response != null) {

          this.categories = response.result;

        }

        this.itemsLoading = false;
      },
        error => {
          this.itemsLoading = false;
        })
    );
  }

  /**
   * 
   */
  getList(type: string = null): void {


    this.progressRef.start();
    this.loading = true;
    this.countSelectedFiles = 0;
    // this.products = [];

    this.setListParams();


    this.apiProducts.getList(this.listParams).subscribe((response: Res) => {
      console.log('[RESPONSE] getProducts: ', response);

      if (response != null && response.result != null) {

        this.products = response.result.productsList;

        this.amount = response.result.count;

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }

        this.paginationService.setPaginationData(this.paginationInput);

        for (let product of this.products) {

          product['checked'] = false;
          product['isContextMenu'] = false;
          // product['filling'] = product.filling.replace('%', "");

          product.attributes.forEach((attr) => {

            attr['editable'] = false;
            this.passSecurity(attr);

          })

          this.getImageContent(product);
          this.getImages(product);
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  refreshList () {

    

  }

  openWindowWithButton(pop:any)
  {
    pop.open()
  }

  /**
   * 
   * @param category_id - массив id-шек из списка категорий
   * @param conditions  - объект со значениями из полей в фильтре
   */
  setListParams(): void {

    this.selectedOperatorsForCondition == 'AND' ? this.condition = { AND: [] } : this.condition = { OR: [] };

    if (this.filterConditionData.length > 0) {

      for (let f of this.filterConditionData) {

        this.condition[this.selectedOperatorsForCondition].push(f);
      }
    }

    if (this.categoryCondition.value.length > 0) {

      this.condition[this.selectedOperatorsForCondition].push(this.categoryCondition);
    }

    this.filter = {
      condition: this.selectedOperatorsForCondition,
      categories_id: this.categoriesIds,
      sort: this.sort != null ? this.sort : {},
      attribute: this.filterConditionData
    }

    this.listParams = {
      attrs: this.configuredAttirubes ? this.configuredAttirubes : this.defaultAttrsForTable,
      filter: this.filter,
      // object: 'products',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
   * 
   */
  passSecurity(attrs: any) {

    let primitiveParams: string;

    if (attrs.present_type_id == 'TAGS' && attrs.attribute_additional_info != null) {

      attrs.attribute_additional_info.forEach(attr => {

        primitiveParams = attr.graphic_primitive.primitive_params
        primitiveParams = primitiveParams.replace('color', attr.color)
        attr['tagHtml'] = this.sanitizer.bypassSecurityTrustHtml(primitiveParams) as SafeHtml;

      });
    }
  }

  /**
   * 
   * @param styles 
   * @returns 
   */
  getTagStyle(styles) {
    return {
      width: styles.width + styles.width_height_unit,
      height: styles.height + styles.width_height_unit,
      display: 'block',
      margin: '0 5px 0 0'
    }
  }

  /**
   * 
   */
  getAttributesIdsForDisplay() {

    let params: ReferenceParams = {
      ref_name: 'configured_attributes',
      filter: {

      }
    }

    this.subscriptions.add(
      this.apiProducts.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("ATTRS CONFIGURE: ", response);


        if (response.result != null && response.result.data != null) {

          this.configuredData = response.result.data;

          this.configuredAttirubes = response.result.data.filter(val => val.id).map(({ id }) => id);

          //получаем список атрибутов затем вызываем список продуктов
          this.getList();
        }
      })
    );

  }

  /**
   * 
   */
  attrsSettings() {
    // Ensure custom side-panel backdrop is removed before opening ng-bootstrap modal.
    this.hiddenCategory = false;
    this.hiddenFilter = false;

    let data = {
      attributes: this.configuredAttirubes ? this.configuredAttirubes : this.defaultAttrsForTable
    }

    this.dialogModal.open(data, AttributeModelForProductTableComponent, 'lg', '').then(
      (result) => {

        if (result) {

          this.getAttributesIdsForDisplay();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
 * 
 * @param attr 
 * @returns 
 */
  checkRulesForEditAttrs(attr: AttributeModel) {

    if (this.configuredData.length > 0) {

      return this.configuredData.find(val => val.id == attr.id).editable;
    }

  }

  /**
   * 
   * @param attr_name 
   * @param columnName 
   */
  sortData(attr_id: string) {

    const rotate: { [key: string]: ProductsSortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };

    if (this.sort.sortBy == attr_id) {

      this.headerDirection[0].direction = rotate[this.headerDirection[0].direction];

      this.sort.direction = this.headerDirection[0].direction;

    } else {


      let directionObj = {
        direction: this.direction
      }

      this.headerDirection.push(directionObj);

      // this.headerDirection[0][this.direction] = this.direction;

      let sortObj = {
        sortBy: attr_id,
        direction: this.direction
      }

      this.sort = sortObj;

    }

    console.log("SORT: ", this.sort);


    // let index = this.sort.findIndex(val => val.sortBy == attr_id);

    // if (index > -1 && this.sort[index].sortBy == attr_id) {

    //   this.headerDirection[index].direction = rotate[this.headerDirection[index].direction];

    //   this.sort[index].direction = this.headerDirection[index].direction;

    // }
    // else {

    //   let directionObj = {
    //     direction: this.direction
    //   }

    //   this.headerDirection.push(directionObj);

    //   let sortObj = {
    //     sortBy: attr_id,
    //     direction: this.direction
    //   }

    //   this.sort = sortObj;
    // }



    // this.getList(this.form.value.filters);
    this.getList();
  }

  /**
   * 
   * @param attr_id 
   * @returns 
   */
  checkDirection(attr_id) {

    return this.sort.sortBy == attr_id ? this.sort.direction : '';

    // let columnDirection = this.sort.find(val => val.sortBy == attr_id);

    // return columnDirection != null ? columnDirection.direction : null;

  }

  isHiddenProductColumn(attr: any): boolean {
    if (!attr || !attr.name) {
      return false;
    }

    const normalizedName = String(attr.name).toLowerCase().replace(/\s+/g, ' ').trim();
    return this.hiddenColumnNames.includes(normalizedName);
  }

  getVisibleProductAttributes(attributes: any[]): any[] {
    if (!Array.isArray(attributes)) {
      return [];
    }

    return attributes.filter((attr) => !this.isHiddenProductColumn(attr));
  }


  /**
   * 
   * @param obj 
   * @returns 
   */
  isEmptyObject(obj) {

    return (obj && (Object.keys(obj).length === 0));

  }


  /**
   * 
   * @param event PaginationPageEvent
   */
  pageEvent(event: PaginationPageEvent): void {


    this.paginationOutput = event;

    this.filterConditionData.length == 0 && this.categoryCondition.value.length == 0 ? this.getList() : this.getList(), this.paginationOutput.pageNumber = 1;

  }


  /**
   * 
   * @param product Product
   */
  getImageContent(product: Product): void {

    if (product.main_photo && product.main_photo != null) {

      this.subscriptions.add(
        this.fileService.getImage(product.main_photo).subscribe((response: any) => {

          if (response != null) {

            product['file_small'] = response.result.small;
          }
        })
      );
    }
  }


  /**
   * 
   * @param product 
   */
  getImages(product: Product): void {

    this.subscriptions.add(
      this.fileService.getImages(product.id).subscribe((response: any) => {

        if (response != null) {
          product['file_urls'] = response.result || [];

          product['file_content'] = response.result.map((url, index) => {

            return new Image(index, { img: url })
          });
          console.log('[PRODUCTS_GALLERY] images-loaded', {
            productId: product.id,
            imagesCount: product['file_content'] ? product['file_content'].length : 0,
            responseCount: response.result ? response.result.length : 0
          });
        } else {
          console.log('[PRODUCTS_GALLERY] images-loaded:empty-response', {
            productId: product.id
          });
        }
      }, (error) => {
        console.log('[PRODUCTS_GALLERY] images-load-error', {
          productId: product.id,
          error
        });
      })
    );
  }


  /**
   * 
   * @param id 
   */
  openModalViaService(product?: Product, source: string = 'unknown') {
    console.log('[PRODUCTS_GALLERY] click-open', {
      source,
      productId: product ? product.id : null,
      hasFileSmall: product ? !!product['file_small'] : null,
      fileContentType: product && product['file_content'] ? typeof product['file_content'] : null,
      fileContentLength: product && product['file_content'] ? product['file_content'].length : null,
      isGalleryOpen: this.isGalleryOpen
    });
    if (!product) {
      console.log('[PRODUCTS_GALLERY] click-open:skip-no-product');
      return;
    }
    if (product && (!product['file_content'] || product['file_content'].length === 0)) {
      console.log('[PRODUCTS_GALLERY] click-open:skip-empty-images', {
        productId: product.id
      });
      return;
    }
    const fallbackImageUrl = this.getProductPrimaryImageUrl(product);
    if (fallbackImageUrl) {
      console.log('[PRODUCTS_GALLERY] open-fallback-image-modal', {
        source,
        productId: product.id,
        imageUrlLength: fallbackImageUrl.length
      });
      this.openImage(fallbackImageUrl);
      return;
    }
    this.activeGalleryImages = product['file_content'];
    this.isGalleryOpen = true;
    console.log('[PRODUCTS_GALLERY] openGallery-call', {
      galleryId: 0,
      initialIndex: 0,
      activeImagesCount: this.activeGalleryImages.length,
      productId: product.id
    });
    setTimeout(() => this.galleryService.openGallery(0, 0), 0);
  }

  private getProductPrimaryImageUrl(product: Product): string | null {
    const urls = product ? product['file_urls'] : null;
    if (Array.isArray(urls) && urls.length > 0 && urls[0]) {
      return String(urls[0]);
    }

    const images = product ? product['file_content'] : null;
    if (!Array.isArray(images) || images.length === 0) {
      return null;
    }

    const candidate = images[0] as any;
    if (candidate && typeof candidate.img === 'string' && candidate.img.length > 0) {
      return candidate.img;
    }
    if (candidate && candidate.modal && typeof candidate.modal.img === 'string' && candidate.modal.img.length > 0) {
      return candidate.modal.img;
    }

    return null;
  }


  /**
   * 
   * @param index 
   */
  getAttributes(index: number = 0): void {

    let searchValue: string = '';

    let params: ReferenceParams = {
      ref_name: 'attributes',
      filter: {
        name: searchValue,
        type: ['INPUT', 'TEXTAREA']
      }
    }

    this.subscriptions.add(
      this.apiProducts.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("ATTRS: ", response);


        if (response != null) {

          this.attributes = response.result;

        }
      })
    );

  }


  /**
   * 
   */
  getOperators(): void {

    let params: ReferenceParams = {
      ref_name: 'filter_conditions_operators',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiProducts.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("DATA: ", response);


        if (response != null) {

          this.operators = response.result;
        }
      })
    );

  }

  /**
   * 
   */
  openDialogAttachingCertificate(): void {

    let data = {
      type: 'attach',
      cert_type: '',
      products: this.products.filter(val => val.checked)
    }

    this.dialogModal.open(data, AttachingCertificateComponent).then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  // /**
  //  * 
  //  */
  // toggleCategoryBox(): void {

  //   this.filterCategoryStatus = !this.filterCategoryStatus;
  //   this.setStateCategoryBoxInLocalStorage();
  // }


  // /**
  //  * 
  //  */
  setStateCategoryBoxInLocalStorage(): void {

    localStorage.setItem('state_category_box', this.filterCategoryStatus && this.permissionAccess.check('REFERENCES_CATEGORIES') ? '1' : '0');
  }


  // /**
  //  * 
  //  */
  // setStateCategoryBox(): void {

  //   let state: string = localStorage.getItem('state_category_box');

  //   if (state) {

  //     this.filterCategoryStatus = state == '1' ? true : false;
  //     return;
  //   }

  //   this.filterCategoryStatus = false;
  //   this.setStateCategoryBoxInLocalStorage();
  // }



  /**
   * 
   */
  applyFilterData(data: any) {

    // Обнуляем счетчик
    this.countSelectedFiles = 0
    // Обнуляем пагинацию(сбрасываем на дефолтное значение)
    this.paginationOutput = null;
    this.selectedOperatorsForCondition = data.operatorForContion;
    this.filterConditionData = data.form.filters;
    this.getList();

  }


  /**
   * 
   */
  resetFilter() {

    // Обнуляем пагинацию(сбрасываем на дефолтное значение)
    this.paginationOutput = null;
    // Обнуляем счетчик
    this.countSelectedFiles = 0
    // Обнуляем значение фильтра
    this.filterConditionData = [];
    this.categoriesIds = [];
    // Обнуляем условие оператор фильтрации
    this.condition[this.selectedOperatorsForCondition] = [];
    this.getList();
  }

  /**
   * Признак того, что хотя бы один фильтр активен (значения фильтра или выбранные категории).
   */
  isFilterActive(): boolean {

    return (Array.isArray(this.filterConditionData) && this.filterConditionData.length > 0)
      || (Array.isArray(this.categoriesIds) && this.categoriesIds.length > 0);
  }

  /**
   * 
   * @param ids 
   */
  onConfirm(ids: string[]) {

    let message = 'Вы действительно хотите удалить?';
    
    // this.dialogModal.open(message, ConfirmActionComponent, 'onConfirm').then(
    this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
      (result) => {

        if (result) {

          this.onDelete(ids);
        }
      },
      () => { console.log('Rejected!'); }
    );

  }

  // /**
  //  * 
  //  */
  // opneCategory() {

  //   this.changeItem = this.eventCategoryList

  //   let data = {
  //     categoryType: this.categoryType
  //   }

  //   console.log("thisChangeItem", data);
    

  //   this.dialogModal.open(data, TreeViewComponent, 'openCategory').then(
  //     (result) => {

  //       if (result) {

  //         this.eventCategoryList(result)

  //       }
  //     },
  //     () => { console.log('Rejected!'); }
  //   );

  // }


  /**
   * 
   * @param ids 
   */
  onDelete(ids: string[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiProducts.delete({ id: ids }).subscribe(response => {

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   */
  deleteSelected(): void {

    let ids = [...new Set(this.products.filter(val => val.checked).map(({ id }) => id))];
    this.onDelete(ids);
  }


  /**
   * 
   */
  downloadMediaFiles() {

    let ids = [...new Set(this.products.filter(val => val.checked).map(({ id }) => id))];
    let name = [...new Set(this.products.filter(val => val.checked).map(({ name }) => name))];
    let data = {
      id: ids
    }

    this.fileService.downloadMediaFiles(data, name);
  }


  /**
   * 
   */
  customerIntegration() {

    let data = null;

    this.dialogModal.open(data, CustomersIntegrationComponent).then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * 
   * @returns 
   */
  checkActions(): boolean {
    return this.permissionAccess.check('PRODUCTS_DELETE')
      || this.permissionAccess.check('ADDINFO_EDIT')
      || this.permissionAccess.check('PRODUCT_PROFILE');
  }

  // CHECKBOX
  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.products[index].checked = event.target.checked;
    this.productsData = this.products.filter(val => val.checked);
    this.counterSelectedFiles();
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    let pc = this.products.filter(val => val.checked).length;
    
    this.products.forEach(x => pc > 0 ? x.checked = false : x.checked = event.target.checked);
    this.productsData = this.products.filter(val => val.checked);
    
    this.counterSelectedFiles();
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.products.length == 0) return false;

    return this.products.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.products.length;
    let pc = this.products.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.products.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }

  /**
  * 
  */
  checkOrg() {

    if (this.currentOrgData && this.currentOrgData.roles.length > 0) {

      for (let r of this.currentOrgData.roles) {

        if (r.name == 'Торговая сеть') {

          this.checkRole = true;
          break;
        }
      }
    }

  }

  /**
   * 
   */
  chooseAllFiles() {

    this.subscriptions.add(

      this.apiBasic.getAlListIds('products', this.listParams).subscribe((response: Res) => {
        console.log("[RESPONSE] getAllProducts/ID: ", response);

        if (response != null) {

          this.allIds = response.result;

          this.products.forEach(x => x.checked = true);

          this.countSelectedFiles = this.amount;

        }

        this.itemsLoading = false;
      },
        error => {
          this.itemsLoading = false;
        })

    );
  }

  /**
   * 
   */
  unChooseAllFiles() {
    this.products.forEach(x => x.checked = false);
    this.allIds = [];
    this.countSelectedFiles = 0;
  }

  /**
  * 
  */
  counterSelectedFiles() {

    this.countSelectedFiles = this.products.filter(val => val.checked).length;
  }

  /**
   *
   * @param file
   */
  openImage(file: any): void {

    this.dialogModal.open(file, ImagesComponent, 'lg', 'images-window').then();
  }


  /**
   * 
   * @param event 
   * @param product 
   * @param field 
   */
  displayContextMenu(event, product, field): void {

    this.contextFieldName = field;

    event.preventDefault();

    for (let product of this.products) {
      product.isContextMenu = false;
    }

    product.isContextMenu = true;

    this.rightClickData = [
      {
        menuText: "Открыть в новой вкладке",
        menuLink: "/products/" + field + '/',
        itemId: product.id
      }
    ];

    this.rightClickMenuPositionX = event.clientX;
    this.rightClickMenuPositionY = event.clientY;

  }

  /**
   * 
   * @returns 
   */
  getRightClickMenuStyle() {
    return {
      position: 'fixed',
      left: `${this.rightClickMenuPositionX}px`,
      top: `${this.rightClickMenuPositionY}px`
    }
  }



  eventCloseCategory(event) {

    console.log("EVENT", event);
    
    this.hiddenCategory = event;
  }

  eventCloseFilter(event) {

    console.log("EVENT", event);
    
    this.hiddenFilter = event;
  }

  // @HostListener("focusout", ["$event"])
  //  onListenerTriggered(event: any): void {
  //      console.log("HAMID JIVOTNOE", event);
       
  //  }

  /**
   * 
   */
  @HostListener('document:click')
  documentClick(): void { 

    for (let product of this.products) {
      product.isContextMenu = false;
    }
  }

  /**
   * 
   */
  toProfile(id: string) {

    this.router.navigate(['products', 'profile', id]);
  }


  /**
   * 
   * @param event 
   */
  onWheel(event: WheelEvent): void {

    this.widgetsContent.nativeElement.scrollLeft += event.deltaY;
    event.preventDefault();
  }


  /**
   * 
   */
  reloadList() {
    this.productsData = [];
    this.getList();
  }
}

